import type { AlertProps } from '@mui/material';
import { Box, useTheme } from '@mui/material';
import { Toast } from '@tix-ticketing/ui-components';
import { toastTransitionProps } from '@tix-ticketing/ui-theme';
import { SnackbarProvider } from 'notistack';
import { MiniCart } from 'components/common/cart/mini-cart';
import { ExchangeAddGuardProvider } from 'components/common/exchange/exchange-add-guard';
import type { ProductAddedToastOptions } from 'components/products/product-added-toast';
import { ProductAddedToast, ProductAddedToastPosition, productAddedToastContainerClass } from 'components/products/product-added-toast';
import { useAppState } from 'lib/app-state';
import { useDedicatedOrderRoute } from 'lib/dedicated-order';
import { Navbar } from './navbar/navbar';
interface AppLayoutProps {
  children: React.ReactNode;
}
declare module 'notistack' {
  interface VariantOverrides {
    toast: {
      alertProps: AlertProps;
    };
    productAdded: ProductAddedToastOptions;
  }
}
export const AppLayout = ({
  children
}: AppLayoutProps) => {
  const {
    isCartOpen,
    setIsCartOpen,
    navbarExtraHeight,
    navbarBannerHeight
  } = useAppState();
  const theme = useTheme();
  // The mini cart shows the buyer's cart, which a reservation or renewal flow
  // keeps out of the way.
  const isDedicatedOrderFlow = !!useDedicatedOrderRoute();
  return <SnackbarProvider {...toastTransitionProps(theme)} Components={{
    toast: Toast,
    productAdded: ProductAddedToast
  }} classes={{
    containerAnchorOriginTopRight: productAddedToastContainerClass
  }}>
      <ProductAddedToastPosition />
      <ExchangeAddGuardProvider>
        <div>
          <Navbar />
          <Box sx={theme => ({
          // The visible viewport, not the large one: on mobile `vh` is the
          // height the page gets once the browser's toolbar has collapsed,
          // which leaves anything anchored to the bottom underneath it.
          height: '100dvh',
          paddingTop: `${96 + navbarExtraHeight + navbarBannerHeight}px`,
          [theme.breakpoints.down('sm')]: {
            paddingTop: `${64 + navbarExtraHeight + navbarBannerHeight}px`
          }
        })} component="main">
            {children}
          </Box>
        </div>
        {!isDedicatedOrderFlow && <MiniCart isCartOpen={isCartOpen} setIsCartOpen={setIsCartOpen} />}
      </ExchangeAddGuardProvider>
    </SnackbarProvider>;
};